import type { SavedCity } from "@/components/choghadiya/ChoghadiyaCitySelector";

/** Shared server/client default; keep executable server code out of the client boundary. */
export const DEFAULT_SHUBH_CITY: SavedCity = {
  name: "New Delhi",
  latitude: 28.6139,
  longitude: 77.209,
  timezone: "Asia/Kolkata",
  country: "IN",
};
